import { css } from "styled-components";

export const ghostPrimaryStyle = css`
  color: var(--link-default);
  background-color: var(--button-primary-default);
  font-weight: var(--font-weight-semi-bold);

  svg path {
    fill: transparent !important;
    stroke: var(--link-default) !important;
  }

  &:hover {
    background-color: var(--button-primary-default);
    color: var(--button-primary-hover) !important;

    svg path {
      fill: transparent !important;
      stroke: var(--button-primary-hover) !important;
    }
  }

  &:focus {
    outline: none !important;
    color: var(--link-default) !important;
    background-color: var(--button-primary-default) !important;

    svg path {
      fill: transparent !important;
      stroke: var(--link-default) !important;
    }
  }

  &:focus-visible {
    outline: 1px solid var(--button-ghost-focused-border) !important;
    box-shadow: 0px 0px 0px 2px var(--button-focused-shadow) !important;
  }

  &:active {
    color: var(--button-primary-clicked) !important;

    svg path {
      fill: transparent !important;
      stroke: var(--button-primary-clicked) !important;
    }
  }

  &[disabled] {
    background-color: var(--button-primary-default);
    color: var(--link-default);
    opacity: 0.7;

    &:hover {
      background-color: var(--button-primary-default);
      color: var(--link-default);
      opacity: 0.7;
    }
  }
`;
